module.exports = __webpack_public_path__ + "static/media/ReservationCheckIconProcess.1bb34edf.jpg";